import { Component, ChangeDetectionStrategy } from '@angular/core';
import { OptionComponent } from '../abstract/option.component';

@Component({
  selector: 'option-number',
  styleUrls: ['./option-number.component.scss'],
  templateUrl: './option-number.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptionNumberComponent extends OptionComponent {}
